import $ from 'jquery';

const selectors = {
  header: '#shopify-section-header',
  mainContent: '#MainContent'
};

const classes = {
  fixed: 'fixed-top'
};

(function () {

  var headerHeight, threshold, addPaddingTo;

  var setValues = function () {
    var isDesktop = window.matchMedia("(min-width: 768px)").matches;

    headerHeight = $(selectors.header).height();
    threshold = 0;
    addPaddingTo = $(selectors.header + " + *").is(":visible") ? $(selectors.header + " + *") : $(selectors.mainContent);
  };

  var reset = function () {
    // Scroll to the top before setting values
    // $('html').animate({
    //   scrollTop: 0

    // }, function () {
      if (addPaddingTo) {
        $(selectors.header).removeClass(classes.fixed);
        addPaddingTo.css("margin-top", 0);
      }

      setValues();

      $(selectors.header).addClass(classes.fixed);
      addPaddingTo.css("margin-top", headerHeight);
    // });
  };

  setValues();
  reset();

  $(window).resize(function () {
    // Wait until resizing is complete
    clearTimeout(this.id);
    this.id = setTimeout(reset, 500);
  });

  // $(window).scroll(function () {
  //   var currPos = $(document).scrollTop();

  //   if (currPos >= threshold) {
  //     $(selectors.header).addClass(classes.fixed);
  //     addPaddingTo.css("margin-top", headerHeight);
  //   } else {
  //     $(selectors.header).removeClass(classes.fixed);
  //     addPaddingTo.css("margin-top", 0);
  //   }
  // });

})();